import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService, MiaAuthHttpService } from '@mobileia/authentication';
import { Observable } from 'rxjs';
import { ApiResponse, ApiPagination } from '@mobileia/core';
import { Synonym, SynonymGroup } from '../entities/synonym';
import { environment } from 'src/environments/environment';

export interface SynonymGroupListParams {
  page?: number;
  per_page?: number;
  search?: string;
}

export interface SynonymListParams {
  page?: number;
  per_page?: number;
  search?: string;
  group_id?: number;
}

@Injectable({
  providedIn: 'root'
})
export class SynonymService extends MiaAuthHttpService {

  private readonly baseUrl = environment.baseUrl;

  constructor(
    protected http: HttpClient,
    protected authService: AuthenticationService
  ) {
    super(http, authService);
  }

  // ============ Synonym Groups ============

  /**
   * Fetch paginated list of synonym groups
   */
  listGroups(params: SynonymGroupListParams = {}): Observable<ApiResponse<ApiPagination<SynonymGroup>>> {
    return this.postAuthObject(this.baseUrl + 'admin/synonym-group/list', params);
  }

  /**
   * Get a single synonym group by ID
   */
  getGroup(id: number): Observable<ApiResponse<SynonymGroup>> {
    return this.postAuthObject(this.baseUrl + 'admin/synonym-group/get', { id });
  }

  /**
   * Create or update a synonym group
   * If id is provided, it updates; otherwise creates
   */
  saveGroup(group: Partial<SynonymGroup>): Observable<ApiResponse<SynonymGroup>> {
    return this.postAuthObject(this.baseUrl + 'admin/synonym-group/save', group);
  }

  /**
   * Delete a synonym group (cascade deletes all synonyms)
   */
  removeGroup(id: number): Observable<ApiResponse<boolean>> {
    return this.postAuthObject(this.baseUrl + 'admin/synonym-group/remove', { id });
  }

  // ============ Synonyms ============

  /**
   * Fetch paginated list of synonyms
   */
  listSynonyms(params: SynonymListParams = {}): Observable<ApiResponse<ApiPagination<Synonym>>> {
    return this.postAuthObject(this.baseUrl + 'admin/synonym/list', params);
  }

  /**
   * Create or update a synonym
   * If id is provided, it updates; otherwise creates
   */
  saveSynonym(synonym: Partial<Synonym>): Observable<ApiResponse<Synonym>> {
    return this.postAuthObject(this.baseUrl + 'admin/synonym/save', synonym);
  }

  /**
   * Delete a single synonym
   */
  removeSynonym(id: number): Observable<ApiResponse<boolean>> {
    return this.postAuthObject(this.baseUrl + 'admin/synonym/remove', { id });
  }
}
